import * as yup from 'yup'
import { THIS_FIELD_IS_REQUIRED_MESSAGE } from '../../constants/validations'
import { DssCompliance, IntegrationTypeRequired } from '../../graphql'
import { isEmpty } from 'lodash'

export const PciDssComplianceInputSchema = yup.object().shape({
  integrationTypeSelect: yup
    .mixed()
    .nullable()
    .test('is-valid-based-on-list-value', THIS_FIELD_IS_REQUIRED_MESSAGE, function (value) {
      return (
        isEmpty(value) ||
        Object.values(IntegrationTypeRequired).includes(value as IntegrationTypeRequired)
      )
    }),
  pciCompliance: yup
    .mixed()
    .nullable()
    .test('is-valid-based-on-list-value', THIS_FIELD_IS_REQUIRED_MESSAGE, function (value) {
      return isEmpty(value) || Object.values(DssCompliance).includes(value as DssCompliance)
    }),
})
